import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_BULGARIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Номер', 'Номер на карта'],
    cardExpiry: ['Валидност', 'Дата на изтичане'],
};

export const TUI_BULGARIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Популярни',
        history: 'Последни',
        placeholder: 'Търсене',
        hotkey: 'за търсене',
        all: 'Всички',
        empty: 'Няма резултати',
    },
};

export const TUI_BULGARIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Отказ',
    done: 'Готово',
    more: 'Още',
    otherDate: 'Друга дата...',
    showAll: 'Покажи всички',
    hide: 'Скрий',
    mobileCalendarTexts: [
        'Избери ден',
        'Избери период',
        'Избери дни',
    ],
    range: ['От', 'До'],
    countTexts: ['Повече', 'По-малко'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'ден.месец.година',
        MDY: 'месец.ден.година',
        YMD: 'година.месец.ден',
    },
    digitalInformationUnits: ['Байт', 'Килобайт', 'Мегабайт'],
    passwordTexts: ['Покажи парола', 'Скрий парола'],
    copyTexts: ['Копирай', 'Копирано'],
    shortCalendarMonths: [
        'Яну',
        'Фев',
        'Мар',
        'Апр',
        'Май',
        'Юни',
        'Юли',
        'Авг',
        'Сеп',
        'Окт',
        'Ное',
        'Дек',
    ],
    pagination: ['Предишна страница', 'Следваща страница'],
    fileTexts: {
        loadingError: 'Грешка при зареждане',
        preview: 'Преглед',
        remove: 'Премахни',
    },
    inputFileTexts: {
        defaultLabelSingle: 'или го пуснете тук',
        defaultLabelMultiple: 'или ги пуснете тук',
        defaultLinkSingle: 'Избери файл',
        defaultLinkMultiple: 'Избери файлове',
        maxSizeRejectionReason: 'Файлът е твърде голям',
        formatRejectionReason: 'Невалиден файлов формат',
        drop: 'Пуснете файл тук',
        dropMultiple: 'Пуснете файлове тук',
    },
    multiSelectTexts: {
        all: 'Избери всички',
        none: 'Избери нищо',
    },
    confirm: {
        yes: 'Да',
        no: 'Не',
    },
    previewTexts: {
        rotate: 'Завърти',
    },
    zoomTexts: {
        zoomOut: 'Отдалечи',
        zoomIn: 'Приближи',
        reset: 'Нулирай',
    },
    phoneSearch: 'Търсене на държава или код',
};

export const TUI_BULGARIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Плосък цвят', 'Цветов градиент'],
    toolbarTools: {
        undo: 'Отмени',
        redo: 'Върни',
        font: 'Шрифт',
        fontStyle: 'Стил на шрифта',
        fontSize: 'Размер на шрифта',
        bold: 'Удебелен',
        italic: 'Курсив',
        underline: 'Подчертан',
        strikeThrough: 'Зачертан',
        justify: 'Подравняване',
        justifyLeft: 'Подравняване вляво',
        justifyCenter: 'Центриране',
        justifyRight: 'Подравняване вдясно',
        justifyFull: 'Двустранно подравняване',
        list: 'Списък',
        indent: 'Увеличи отстъп',
        outdent: 'Намали отстъп',
        unorderedList: 'Неномериран списък',
        orderedList: 'Номериран списък',
        quote: 'Цитат',
        foreColor: 'Цвят на текста',
        backColor: 'Цвят на фона',
        hiliteColor: 'Цвят за маркиране',
        clear: 'Изчисти',
        link: 'Връзка',
        attach: 'Прикачи файл',
        tex: 'Вмъкни TeX',
        code: 'Код',
        image: 'Вмъкни изображение',
        insertHorizontalRule: 'Вмъкни хоризонтална линия',
        superscript: 'Горен индекс',
        subscript: 'Долен индекс',
        insertTable: 'Вмъкни таблица',
        insertGroup: 'Вмъкни група',
        hiliteGroup: 'Маркирай група',
        removeGroup: 'Премахни група',
        insertAnchor: 'Вмъкни котва',
        mergeCells: 'Обедини клетки',
        splitCells: 'Раздели клетки',
        rowsColumnsManaging: 'Управление на редове и колони',
        cellColor: 'Цвят на клетката',
        setDetails: 'Задай детайли',
        removeDetails: "Премахни детайли",
    },
    editorEditLink: {
        urlExample: 'пример.com',
        anchorExample: 'котва',
    },
    editorTableCommands: [
        ['Вмъкни колона преди', 'Вмъкни колона след'],
        ['Вмъкни ред преди', 'Вмъкни ред след'],
        ['Премахни колона', 'Премахни ред'],
    ],
    editorCodeOptions: ['Код в текст', 'Блок с код'],
    editorFontOptions: {
        small: 'Малък',
        large: 'Голям',
        normal: 'Нормален',
        title: 'Заглавие',
        subtitle: 'Подзаглавие',
    },
};

export const TUI_BULGARIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Покажи/Скрий',
    paginationTexts: {
        pages: 'Страници',
        linesPerPage: 'Редове на страница',
        of: 'от',
    },
};

export const TUI_BULGARIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Януари',
        'Февруари',
        'Март',
        'Април',
        'Май',
        'Юни',
        'Юли',
        'Август',
        'Септември',
        'Октомври',
        'Ноември',
        'Декември',
    ],
    close: 'Затвори',
    clear: 'Изчисти',
    nothingFoundMessage: 'Няма намерени резултати',
    defaultErrorMessage: 'Невалидна стойност',
    spinTexts: ['Предишен', 'Следващ'],
    shortWeekDays: ['Пон', 'Вто', 'Сря', 'Чет', 'Пет', 'Съб', 'Нед'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_BULGARIAN_LANGUAGE: TuiLanguage = {
    name: 'bulgarian',
    ...TUI_BULGARIAN_LANGUAGE_CORE,
    ...TUI_BULGARIAN_LANGUAGE_KIT,
    ...TUI_BULGARIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_BULGARIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_BULGARIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_BULGARIAN_LANGUAGE_LAYOUT,
};